var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41541 7.36364L3.70013 8.97174C3.05952 9.57233 2.69113 10.3895 2.69786 11.2483C2.70459 12.1072 3.06492 12.9293 3.73593 13.539C4.38618 14.1681 5.26333 14.5059 6.17925 14.5122C7.11607 14.5187 7.96709 14.1927 8.60773 13.5921L10.323 11.984M12.514 9.96929L14.2292 8.36119C14.8699 7.76061 15.2382 6.94343 15.2315 6.08459C15.2248 5.22576 14.8644 4.40359 14.1934 3.79394C13.5433 3.18447 12.6663 2.84663 11.7503 2.84032C10.8342 2.83401 9.96244 3.15978 9.32179 3.76038L7.60651 5.36848M6.36357 11.062L11.5094 6.23774M3.77586 3.71606L2.92622 2.91951M6.72611 2.31295L6.86511 1M1 6.49839L2.45201 6.36328M14.2241 13.2839L15.0738 14.0805M11.2739 14.6871L11.1349 16M17 10.5016L15.548 10.6367",
    stroke: "#F52626",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickLink);
export default __webpack_public_path__ + "static/media/quick-link.4871dcd9f2c57c82fb68c0980e8244f0.svg";
export { ForwardRef as ReactComponent };